import React from 'react';

import BudgetTagChips from './BudgetTagChips';

/**
 * The Budget tags cell of a template or pack item. An item not yet saved has no tags editor.
 */
export default function BudgetTagsCell({ cell, isNew, onOpen }) {
    if (isNew) {
        return <span className="tw-text-xs tw-italic tw-text-charcoal-75">{$t('Save the item before setting its tags')}</span>;
    }

    return (
        <button
            type="button"
            className="tw-p-0 tw-bg-transparent tw-border-0 tw-text-start tw-cursor-pointer hover:tw-opacity-75"
            title={$t('Budget tags')}
            onClick={onOpen}
        >
            <BudgetTagChips cell={cell || { overrides: false, tags: [] }} />
        </button>
    );
}
